export const checkNullUndefined = val => {
  if (val) {
    if (val.toLowerCase() === 'null' || val.toLowerCase() === 'undefined') {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};
